import { render } from "./UnitInternalOfficeNote.vue?vue&type=template&id=480ea890&ts=true"
import script from "./UnitInternalOfficeNote.vue?vue&type=script&lang=ts"
export * from "./UnitInternalOfficeNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__